import create from 'zustand';

const useViewState = create(set => ({
  connectionsTabOpen: false,
  setConnectionsTabOpen: val => set({ connectionsTabOpen: val }),
  showConnectionsTable: false,
  setShowConnectionsTable: val => set({ showConnectionsTable: val }),
}));

export { useViewState };
